import API from "./API";

export const getSeoAPI = (params) => {
  return API.get(`/seopages?page=${params?.page || 0}&size=${params?.size || 10}`)
  // return API.get(`/seopages?page=0`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSingleSeoAPI = (seoPagesTitle) => {
  return API.get(`/seopages/${seoPagesTitle}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addSeoAPI = (payload) => {
  return API.post("/seopages", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateSeoAPI = (payload) => {
  return API.put("/seopages", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteSeoAPI = (id) => {
  return API.delete(`/seopages/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addSeoImgAPI = (payload) => {
  const formData = new FormData();
  formData.append("file", payload.file);

  return API.post("/seopages/addthumbnail", formData, {
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
